import React from 'react';

const Empty = () => <div data-focus='empty'></div>;

Empty.displayName = 'Empty';

module.exports = Empty;



// WEBPACK FOOTER //
// ./src/empty/index.js